import { Image, Stack, Text } from "@chakra-ui/react";
import RadioBox from "@raiden/library/components/Form/RadioBox";
import RadioGroupRaiden from "@raiden/library/components/Form/RadioGroupRaiden";
import FormController from "@raiden/library/components/ReactHookForm/FormController";
import RGrid from "@raiden/library/components/RGrid";
import { PAYMENTS_METHODS } from "@raiden/library/constants/payments";
import getPaymentsMethodsForType from "@raiden/library/helpers/payments/getPaymentsMethodsForType";
import { useConfiguration } from "@raiden/library/hooks/useConfiguration";
import capitalize from "@splitfire-agency/raiden-library/dist/libraries/utils/capitalize";
import { useWatch } from "react-hook-form";
import { useIntl } from "react-intl";

export const PAYMENTS_CREATE_FORM_ID = "payments-create-form";

export const PAYMENTS_FORM_INFORMATION_FIELDS = ["data.environment_id"];

const BOX_SHADOW = "0 0 0 2px var(--chakra-colors-brandPrimary-500)";

function PaymentsFormPayment() {
  const intl = useIntl();

  const environmentId = useWatch({ name: "data.environment_id" });

  const { configuration } = useConfiguration();

  const type = useWatch({ name: "data.type" });

  const method = useWatch({ name: "data.method" });

  const paymentMethods = Object.entries(
    getPaymentsMethodsForType({
      configuration,
      type,
      onlyAccount: true,
    }),
  );

  const highlightedPaymentMethod =
    paymentMethods.find(
      (paymentMethod) =>
        paymentMethod[0] === process.env.NEXT_PUBLIC_HIGHLIGHTED_PAYMENT_METHOD,
    ) ?? (paymentMethods.length === 1 ? paymentMethods[0] : undefined);

  return (
    <Stack spacing="1rem">
      {environmentId !== "" && (
        <FormController
          name="data.method"
          rules={{ required: true }}
          renderWithFormControl={(field) => (
            <RadioGroupRaiden {...field}>
              <RGrid>
                {highlightedPaymentMethod && (
                  <RadioBox
                    gridColumn="1 / -1"
                    value={highlightedPaymentMethod[0]}
                    isDisabled={field.isDisabled}
                    boxShadow={
                      method === highlightedPaymentMethod[0]
                        ? BOX_SHADOW
                        : undefined
                    }
                    text={
                      <Stack>
                        <Text>
                          {capitalize(highlightedPaymentMethod[1].name)}
                        </Text>

                        {PAYMENTS_METHODS[highlightedPaymentMethod[0]]?.src && (
                          <Image
                            src={
                              PAYMENTS_METHODS[highlightedPaymentMethod[0]]?.src
                            }
                            alt={intl.formatMessage(
                              PAYMENTS_METHODS[highlightedPaymentMethod[0]]
                                ?.label,
                            )}
                          />
                        )}
                      </Stack>
                    }
                    key={highlightedPaymentMethod[0]}
                  />
                )}

                {paymentMethods.length > 1 &&
                  paymentMethods.map(([key, paymentMethod]) =>
                    highlightedPaymentMethod?.[0] !== key ? (
                      <RadioBox
                        value={key}
                        isDisabled={field.isDisabled}
                        boxShadow={method === key ? BOX_SHADOW : undefined}
                        text={
                          <Stack>
                            <Text>{capitalize(paymentMethod.name)}</Text>

                            {PAYMENTS_METHODS[key]?.src && (
                              <Image
                                src={PAYMENTS_METHODS[key]?.src}
                                alt={intl.formatMessage(
                                  PAYMENTS_METHODS[key]?.label,
                                )}
                              />
                            )}
                          </Stack>
                        }
                        key={key}
                      />
                    ) : null,
                  )}
              </RGrid>
            </RadioGroupRaiden>
          )}
        />
      )}
    </Stack>
  );
}

export default PaymentsFormPayment;
